// extracted by mini-css-extract-plugin
export default {"dropdownItem":"PaymentsList_dropdownItem__OvpHC","multi-select-bank-transactions-receipt-assignment":"PaymentsList_multi-select-bank-transactions-receipt-assignment__QjKXW"};